import FingerprintJS from "@fingerprintjs/fingerprintjs";
export default {
    async updateDeviceId({ commit }, deviceId) {
        const fp = await FingerprintJS.load();
        const result = await fp.get();
        commit('setDeviceId', result.visitorId);
    },

    async updateConfigInfo({ commit }, configInfo) {
        commit('setConfigInfo', configInfo);
    },

    updateUuid({ commit }, uuid) {
        commit('setUuid', uuid);
    },

    updateUserInfo({ commit }, userInfo) {
        commit('setUserInfo', userInfo);
    },

    updateNoticeInfo({ commit }, noticeInfo) {
        commit('setNoticeInfo', noticeInfo);
    },

    updaterecents({ commit }, recents) {
        commit('setRecents', recents);
    },

    updateHistoryGames({ commit }, historyGames) {
        commit('setHistoryGames', historyGames);
    },

    updateHomeGames({ commit }, homeGames) {
        commit('setHomeGames', homeGames);
    },

    cleanUuid({ commit }) {
        commit('clearUuid');
    },

    cleanUserInfo({ commit }) {
        commit('clearUserInfo');
    },

    cleanHistoryGames({ commit }) {
        commit('clearHistoryGames');
    }
}


// WEBPACK FOOTER //
// ./src/store/actions.js